<!-- src/components/About.vue -->
<template>
  <div class="footer">
    <div class="ftbd">
      <span>中国法学会&nbsp;&nbsp;版权所有©2019&nbsp;&nbsp;京ICP备10012170号&nbsp;&nbsp;京公网安备110401200001号</span>
      <span>临时办公地址:北京市海淀区皂君庙4号院&nbsp;&nbsp;邮编:100081</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  components: {}
};
</script>

<style scoped lang="scss">
@media all and (max-width: 800px) {
  .footer {
    font-size: 10px !important;
    height: 60px !important;
    position: fixed !important;
    bottom: 0;
    z-index: 999999 !important;
    .ftbd {
      width: 100% !important;
    }
  }
}
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100px;
  // bottom: 0px;
  // position: absolute;
  .ftbd {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 20px 20px 0 0;
    width: 1170px;
    height: 100%;
    background: #c50909;
    span {
      margin-bottom: 5px;
    }
  }
}
</style>
